module.exports = __webpack_public_path__ + "img/cicac.61649f4d.svg";